<template>
  <div class="single-dashboard">
    <div class="img-container">
      概览
    </div>
    <el-row  class="dashboardList">
      <el-col :xs="5" :xl="4" :sm="4" :lg="4" class="text-center">
        
        <a href="/buyer/task/list?type=11&page=1"><span>待接单</span>{{info.need_take}}</a>
      </el-col>
      <el-col :xs="5" :xl="4" :sm="4" :lg="4" class="text-center">
        
        <a href="/buyer/task/list?type=13,14&page=1"><span>待下单</span>{{info.need_order}}</a>
      </el-col>
      <el-col :xs="4" :xl="4" :sm="4" :lg="4" class="text-center">
        
        <a href="/buyer/task/list?type=15&page=1"><span>待发货</span>{{info.need_ship}}</a>
      </el-col>
      <el-col :xs="5" :xl="4" :sm="4" :lg="4" class="text-center">
        
        <a href="/buyer/task/list?type=16&page=1"><span>待收货</span>{{info.need_receiving}}</a>
      </el-col>
      <el-col :xs="5" :xl="4" :sm="4" :lg="4" class="text-center">
        
        <a href="/messages/single"><span>未读消息</span>{{info.unread}}</a>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import api from '../../services/api.js'
let _ = require('lodash')

export default {
  name: 'AddAddress',
  props: ['order', 'packageId', 'groupOrderLine'],
  components: {
  },
  computed: {
  },
  created () {
    this.getOverview()
  },
  data () {
    return {
      info: {}
    }
  },
  methods: {
    async getOverview () {
      let res = await api.getOverview(this)
      this.info = res.body.result
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .single-dashboard {
    position: relative;

    span {
      position: relative;
      top: -5px;
      margin-right: 5px;
      color: black;
    }

    a {
      font-size:33px;
      height: 33px;
      color: #3D69CA;
    }

  }
  .img-container {
    background: url("../../assets/images/Bitmap.png") left no-repeat;
    height: 166px;
    background-color: #f6f6f4;
    line-height: 166px;
    text-align: center;
    font-size:26px;
    margin-bottom: 35px;
  }
  .dashboardList {
    padding-left: 80px;
  }

    @media screen and (max-width:1152px){
      .dashboardList {
        padding-left: 0;
      }

      .single-dashboard {

        a{
          font-size: 18px;
        }

        span {
          display: block;
          margin-right: 0px;
        }
      }

      .img-container {
        background-size: contain;
        height: 58px;
        line-height: 58px;
      }
    }  
</style>



// WEBPACK FOOTER //
// src/pages/single_user_center/Dashboard.vue